export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#2299DA',
    light: '#F7F8F8',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: 'rgba(255, 255, 255, 0.2)',
    contrastText: '#22211F',
  },
  text: {
    brand: '#003F2A',
    primary: '#001A11',
    secondary: '#3E444E',
    tertiaryLight: '#49515B',
    tertiary: '#0F0F0F',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    contrastText: '#22211F',
    onDarkSecondary: 'rgba(255, 255, 255, 0.88)',
    onDarkTertiary: 'rgba(255, 255, 255, 0.75)',
    onDarkEmphasis: 'rgba(255, 255, 255, 0.92)',
  },
  divider: '#D7DBE0',
  background: {
    brandLight: '#003964',
    fill: '#FAFAFA',
    hero1: '#002015B2',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#0A1E38',
    level2: '#B4C94A',
    level1: 'rgba(255, 255, 255, 0.12)',
    tableHead: '#2299DA',
    tableSubhead: '#F1F8FE',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#B6BFA5',
    secondary: '#F5F3F0',
    light: '#EDEDED',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#1377B6',
    ribbon: '#BBE6FE',
    offer: '#D7FFF7',
    stepperCompleted: '#081425',
    border: '#D7DBE0',
    dark:'#2299DA',
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    pricing: '#2299DA',
    learnMore: '#F4F4F4',
    header: '#FAFAFA',
    planCard: '#F7F8F8',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
